import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/home/game_arrow_white.png'


const _hoisted_1 = { class: "details_container" }
const _hoisted_2 = { class: "cards_row" }
const _hoisted_3 = { class: "card1" }
const _hoisted_4 = { style: {"padding":"5px"} }
const _hoisted_5 = { class: "card2" }
const _hoisted_6 = { style: {"padding":"5px"} }
const _hoisted_7 = { class: "card3" }
const _hoisted_8 = { style: {"padding":"5px"} }
const _hoisted_9 = { class: "tabel_content" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }

import { onMounted, ref } from 'vue';
import SelectPopOver from './selectPopOver.vue';
import TimeSelector from './timeSelector.vue';
import { getRewardDetail } from '@/api/agent';
import StatusPopup from '@/components/common/statusPopup.vue';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { formatCurrency } from '@/utils/commonFunction';
import { getRewardDetailDataFunc, RewardDetails, DetailsItem, getNextPageDetailsViewDataFunc } from '@/view/agent/supportScript';
import NoData from '../../components/common/noData.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'detailsView',
  setup(__props) {

const statusRef = ref()
const isSuccess = ref(false)
const toastContent = ref('')
const loadingRef = ref()
const detailsList = ref<DetailsItem[]>([])
const total = ref(0)
const pageSize = ref(20)
const pageNumber = ref(1)
const activeType = ref(1)
const formatYMD = (date: Date): string => {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const dd = String(date.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
};

const today = new Date();
const date = ref(formatYMD(today));

const rewardData = ref<RewardDetails>({
    summary: {
        commission: 0,
        commissionRate: 0,
        total: 0,
    },
    details: [],
    totalPage: 0
})
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const setDate = (value: any) => {
    date.value = value
    detailsList.value = []
    pageNumber.value = 1
    loadingRef.value.open()
    getRewardData()
}
const setActiveType = (type: any) => {
    detailsList.value = []
    activeType.value = type
    loadingRef.value.open()
    getRewardData()

}
const getNextPageRewardData = () => {
  getNextPageDetailsViewDataFunc(total,pageNumber,getRewardData,loadingRef)
}
const getRewardData = () => {
    getRewardDetailDataFunc(
        getRewardDetail,
        date,
        pageNumber,
        activeType,
        rewardData,
        detailsList,
        total,
        loadingRef,
        showError
    )
}

onMounted(() => {
    loadingRef.value.open()
    getRewardData()
})

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(TimeSelector, { onGetSelectedDateData: setDate }),
      _createVNode(SelectPopOver, { onSetActiveType: setActiveType })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_row, {
        class: "cards_row_content",
        justify: "space-between"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, { span: "8" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", null, [
                  _cache[0] || (_cache[0] = _createTextVNode("R$ ")),
                  _createElementVNode("span", null, _toDisplayString(_unref(formatCurrency)(rewardData.value.summary.commission)), 1)
                ]),
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('agent.commission')), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, { span: "7" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", null, _toDisplayString(rewardData.value.summary.commissionRate) + "%", 1)
                ]),
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('agent.commissionRate')), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, { span: "8" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", null, [
                  _cache[1] || (_cache[1] = _createTextVNode("R$ ")),
                  _createElementVNode("span", null, _toDisplayString(_unref(formatCurrency)(rewardData.value.summary.total)), 1)
                ]),
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('agent.totalCommission')), 1)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_9, [
      (activeType.value == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(_component_van_row, { class: "tabel_hed" }, {
              default: _withCtx(() => [
                _createVNode(_component_van_col, {
                  span: "8",
                  class: "head_alignemnet"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('agent.directPlayer')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_col, {
                  span: "2",
                  class: "head_alignemnet"
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createElementVNode("div", { class: "line" }, null, -1)
                  ])),
                  _: 1
                }),
                _createVNode(_component_van_col, {
                  span: "4",
                  class: "head_alignemnet"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('agent.rollover')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_col, {
                  span: "2",
                  class: "head_alignemnet"
                }, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createElementVNode("div", { class: "line" }, null, -1)
                  ])),
                  _: 1
                }),
                _createVNode(_component_van_col, {
                  span: "8",
                  class: "head_alignemnet"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('agent.commission')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailsList.value, (item, index) => {
              return (_openBlock(), _createBlock(_component_van_row, {
                class: "tabel_row",
                key: index
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_col, {
                    span: "9",
                    class: "head_alignemnet"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.fromUid), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_van_col, {
                    span: "6",
                    class: "head_alignemnet"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.turnover), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_van_col, {
                    span: "9",
                    class: "head_alignemnet"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.coin), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (activeType.value == 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_component_van_row, { class: "tabel_hed" }, {
              default: _withCtx(() => [
                _createVNode(_component_van_col, {
                  span: "8",
                  class: "head_alignemnet"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('agent.directPlayer')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_col, {
                  span: "2",
                  class: "head_alignemnet"
                }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createElementVNode("div", { class: "line" }, null, -1)
                  ])),
                  _: 1
                }),
                _createVNode(_component_van_col, {
                  span: "3",
                  class: "head_alignemnet"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('agent.rollover')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_col, {
                  span: "2",
                  class: "head_alignemnet"
                }, {
                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createElementVNode("div", { class: "line" }, null, -1)
                  ])),
                  _: 1
                }),
                _createVNode(_component_van_col, {
                  span: "3",
                  class: "head_alignemnet"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.level')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_col, {
                  span: "2",
                  class: "head_alignemnet"
                }, {
                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createElementVNode("div", { class: "line" }, null, -1)
                  ])),
                  _: 1
                }),
                _createVNode(_component_van_col, {
                  span: "4",
                  class: "head_alignemnet"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('agent.commission')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailsList.value, (item, index) => {
              return (_openBlock(), _createBlock(_component_van_row, {
                class: "tabel_row",
                key: index
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_col, {
                    span: "9",
                    class: "head_alignemnet"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.fromUid), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_van_col, {
                    span: "5",
                    class: "head_alignemnet"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.turnover), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_van_col, {
                    span: "5",
                    class: "head_alignemnet"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.level), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_van_col, {
                    span: "5",
                    class: "head_alignemnet"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.coin), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (detailsList.value.length <= 0)
        ? (_openBlock(), _createBlock(NoData, { key: 2 }))
        : _createCommentVNode("", true),
      (total.value >= pageNumber.value)
        ? (_openBlock(), _createBlock(_component_van_row, { key: 3 }, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, {
                span: "24",
                class: "arrowDown"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: _imports_0,
                    alt: "",
                    onClick: getNextPageRewardData
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"]),
    _createVNode(LoadingScreen, {
      ref_key: "loadingRef",
      ref: loadingRef
    }, null, 512)
  ], 64))
}
}

})